import React, { useState } from 'react';
import { Divider, Grid } from '@material-ui/core';
import ProductTile from '../../components/ProductTile';
import css from './index.module.scss';
import { Redux, Slices } from 'spwa-ui-library';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import AddToCart from './AddToCart';
import { useLocation } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import ProductCustomizationDialog from '../../components/ProductTileList/ProductCustomizationDialog';
import { Skip } from '../../components/Icons';

const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectProductEntities } = Slices.productSlice;
const { getDecimalPoints, selectCountryValidations } = Slices.configSlice;

function ProductsContainer({
  addtoCart,
  mainProductId,
  currentStep,
  category,
  currentStepperId,
  isBundleItem,
  stepId,
  setCurrentStepperId,
  isAddToCartEnabled,
  availableStepCount,
  setShowBundleGroupDialog,
  availableSteps,
  isSkipProceedEnabled,
  title,
}) {
  const intl = useIntl();
  const [showCustomizeProductDialog, setShowCustomizeProductDialog] = useState(0);

  const temp = useSelector((state) => state.tempCart);
  const location = useLocation();
  const isDesktop = useSelector(selectDesktop);
  const productsMap = useSelector(selectProductEntities);
  const bogoProducts = useSelector((state) => state.product.bogoProdList);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const decimalPoints = useSelector(getDecimalPoints);
  const inCusto = temp?.customize?.items?.findIndex(({ id }) => id === +mainProductId);

  let titleOptions = '';
  let subTitle = '';

  if (Math.min(currentStep?.minimum || 1, currentStep?.options?.length || 1) > 1) {
    let tempData = temp?.data?.items?.find(({ id }) => id == mainProductId)?.['bundle']?.[
      currentStep.id
    ];

    if (
      productsMap[mainProductId]?.bundleTypeId == 'bundle' &&
      productsMap[mainProductId]?.typeId == 'simple'
    ) {
      tempData =
        temp?.data?.items?.find(({ id }) => id == mainProductId)?.['bundle']?.[currentStep.id] ||
        temp?.data?.items?.find(({ id }) => id == mainProductId)?.['items']?.[currentStep.id];
    }

    let currentlyAdded =
      Object.values(tempData || {}).reduce((totalQty, product) => {
        return totalQty + (product?.notAdded ? 0 : product?.qty || 1);
      }, 0) || 0;
    let total = Math.min(currentStep.minimum, currentStep?.options?.length || 1);
    titleOptions = intl.formatMessage(
      { id: 'deal_stepper_selected_count' },
      { currentlyAdded, total }
    );

    if (total - currentlyAdded > 0) {
      subTitle = intl.formatMessage(
        { id: 'add_items_to_complete_step' },
        { item: currentStep?.title, count: total - currentlyAdded }
      );
    }
  }

  const locationSearch = new URLSearchParams(location.search);
  const actualStep = parseInt(locationSearch.get('option'));

  return (
    <Grid container className={css.dealContainer} direction="row" spacing={24}>
      <Grid className={css.productContainer}>
        {isDesktop && (
          <div
            className={classNames(css.tabContentHeader, {
              [css.justifySpaceBW]: currentStep?.isAddon == 1,
            })}
          >
            <div className={css.tabContentTitle}>
              {currentStep?.title}
              {titleOptions}
            </div>
            {currentStep?.isAddon == 1 && (
              <div
                className={classNames(css.skipProceedBtn, {
                  [css.disabled]: !isSkipProceedEnabled,
                })}
                onClick={() => {
                  if (isSkipProceedEnabled) {
                    addtoCart();
                  }
                }}
              >
                <span>
                  <FormattedMessage id={'skip_and_proceed'} />
                  <Skip />
                </span>
              </div>
            )}
          </div>
        )}
        {subTitle.length > 0 && <div className={css.subTitleText}>{subTitle}</div>}
        <div className={css.productTilesContainer}>
          {(currentStep?.options || bogoProducts[actualStep])?.map((option, index) => {
            const product = inCusto !== -1 ? temp.customize.items[inCusto] : option || {};
            // IF NO PRODUCT SELECTED
            if (!product) {
              return null;
            }

            // filter product according to category tag
            let isValidTag = false;
            if (!option?.tag) {
              isValidTag = true;
            } else {
              isValidTag =
                Array.isArray(option?.tag) && product.tag.some((tag) => option?.tag === tag);
            }

            if (!isValidTag) return null;

            return (
              <ProductTile
                oldLocation={location}
                setCurrentStepperId={setCurrentStepperId}
                returnURL={window.location.href}
                key={option?.name + '_' + option?.id}
                currentStepperId={currentStepperId}
                category={category || {}}
                onAddCart={addtoCart}
                productObj={option}
                mainProductId={mainProductId}
                isBundleItem={isBundleItem}
                setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                stepId={stepId}
                position={'MainITEM' + option?.id}
                priceTo={
                  product?.tempPrice
                    ? decimalChecker(product?.tempPrice || 0, decimalPoints)
                    : decimalChecker(option?.originalPrice || 0, decimalPoints)
                }
              />
            );
          })}
        </div>
      </Grid>
      {/* <Divider orientation="vertical" flexItem={true} /> */}
      <Grid className={css.dealsCart}>
        <AddToCart
          addtoCart={addtoCart}
          productId={mainProductId}
          stepId={stepId}
          category={category || {}}
          setCurrentStepperId={setCurrentStepperId}
          isAddToCartEnabled={isAddToCartEnabled}
          availableStepCount={availableStepCount}
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          title={title}
        />
      </Grid>
      {showCustomizeProductDialog > 0 && (
        <ProductCustomizationDialog
          productId={mainProductId}
          currentStepperId={currentStepperId}
          setCurrentStepperId={setCurrentStepperId}
          setShowCustomizeProductDialog={setShowCustomizeProductDialog}
          showCustomizeProductDialog={showCustomizeProductDialog}
          oldLocation={JSON.parse(JSON.stringify(location))}
          returnURL={window.location.pathname}
        />
      )}
    </Grid>
  );
}

export default ProductsContainer;
